import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { Box, Flex } from "@chakra-ui/react";
import '../../styles/dsr-display.scss';

import PageLoader from '../../../global/components/helper-components/components/PageLoader';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import { manageDsrFaqContent } from '../../actions/dsr-faq-actions';
import LaunchdeckModal from '../../../global/components/helper-components/components/LaunchdeckModal';



function ConfirmDeleteFaqQuestionModal({
  dsrTemplateId,
  isRoomTemplate,
  handleCloseModal,
  manageFaqProcessingCompleted,
  modalTransferPayloadRedux,
  manageDsrFaqContent
}) {

  // UX Management
  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {
    if (manageFaqProcessingCompleted === true) {

      setShowLoader(false);
      handleCloseModal()
    }

  }, [manageFaqProcessingCompleted, handleCloseModal]);


  const handleConfirmDeleteFaqQuestionButton = () => {
    setShowLoader(true);

    const { dsrId, questionId } = modalTransferPayloadRedux || {}

    const deleteFaqQuestionMetadata = {
      processEvent: 'delete-faq-question',
      payload: {
        dsrId: isRoomTemplate ? dsrTemplateId : dsrId,
        questionId: questionId,
        isRoomTemplate
      }
    }

    manageDsrFaqContent(deleteFaqQuestionMetadata)
  }

  function displayContent() {
    if (showLoader) {
      return (
        <Box w="100%" align="center" >
          <Box px='1em'>
            <PageLoader />
          </Box>
        </Box>
      )
    }

    if (!showLoader) {

      return (
        <Box w='100%' p='1em 1.8em'>
          <Flex w="100%" fontSize='0.875em' color='brandDark.500'>
            This action cannot be undone. Go ahead?
          </Flex>

          <Flex mt='1.625em' w='100%' justify={['center', 'flex-end']}>
            <LaunchdeckButton bg='brandPink.500' w={['100%', 'auto']} color='gray.50' fontSize='0.8em' py='0.4em' onClick={() => handleConfirmDeleteFaqQuestionButton()} label='Delete question' />
          </Flex>
        </Box>
      )
    }
  }

  return (
    <LaunchdeckModal
      title={'You are about to delete this Q&A question'}
      handleCloseModal={() => handleCloseModal()}
      showModal={true}
      maxW='35em'
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}

function mapStateToProps(state) {
  return {
    dsrTemplateId: state.dsrTemplateId.results,
    isRoomTemplate: state.dsrTemplateId.isRoomTemplate,
    modalTransferPayloadRedux: state.modalTransferPayloadRedux.results,
    manageFaqProcessingCompleted: state.manageDsrFaqContentOutcome?.results?.processingCompleted,
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      manageDsrFaqContent
    },
    dispatch,
  )


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfirmDeleteFaqQuestionModal));